// src/services/questionnaireLifecycle.ts
import { api } from "@/lib/apiClient";
import type { QuestionnaireVersionDetail } from "@/types/gro";

export async function deleteQuestionnaire(id: string) {
  return api.delete<void>(`/questionnaires/${id}`);
}

export async function deleteQuestionnaireVersion(versionId: string) {
  return api.delete<void>(`/questionnaires/versions/${versionId}`);
}

export async function unpublishQuestionnaireVersion(versionId: string) {
  return api.post<QuestionnaireVersionDetail>(
    `/questionnaires/versions/${versionId}/unpublish`,
    {},
  );
}
